<template>
    <tr class="room-string" @keydown.enter="save" v-if="data">
        <td v-if="is_new && !group">
            <input type="text" v-model="data.key" placeholder="Keyname" >
        </td>
        <td>
             <input type="text" v-model="data.content" placeholder="Text">
        </td>
        <td>
            <div v-if="data.media">
                <audio controls>
                    <source :src="data.media" type="audio/mpeg">
                </audio>
                <a class="button" @click="removeMedia"><i class="fa fa-remove"></i></a>
            </div>
            <input v-else type="file" @change="updatemedia" placeholder="Ljud" accept=".mp3">
        </td>
        <td v-if="!group">
            <input type="text" v-model="data.group"  placeholder="Grupp">
        </td>
        <td>
            <multiselect v-model="data.age_groups" :multiple="true" track-by="title" :options="age_groups" label="title" :searchable="false"></multiselect>
        </td>
        <td>
            <button class="button is-small is-default" @click="save"><i class="fa fa-save"></i></button>
            <button class="button is-small is-danger" v-if="group" @click="deleteString"><i class="fa fa-trash-o"></i></button>
        </td>
    </tr>

</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>

import RoomData from '@/mixins/RoomContent'
import RoomString from '@/components/partials/RoomString'
import RoomHelp from '@/components/partials/RoomHelp'
import Multiselect from 'vue-multiselect'
export default {
  name: 'RoomString',
  mixins: [RoomData],
  components: { RoomString, RoomHelp, Multiselect },
  data () {
    return {
      data: null,
      mediabutton: null,
      startdata: {
        content: null,
        media: null,
        group: null,
        age_groups: [],
        key: null,
        type: 'string'
      }
    }
  },
  computed: {
  },
  methods: {},
  mounted () {
    this.reset()
  }
}
</script>
